

















































































import Button from '../../../core/components/Button.vue';
import InputFile from '../../../core/components/InputFile.vue';
import SimpleTable from '../../../core/components/SimpleTable.vue';
import SectionTitle from '../../../core/components/SectionTitle.vue';
import Combobox from '../../../core/components/Combobox.vue';
import {
    EventBus,
    sortObjectByPropertyName,
    TypeEventBus,
} from '../../../core/utils';
import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../../core/mixins';
import Loading from 'vue-loading-overlay';
import InfoIcon from '../../../core/components/InfoIcon.vue';
import { TrackingService } from '../../../core/api';

@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        InputFile,
        Combobox,
        InfoIcon
    }
})
export default class UploadPointsOrGeofences extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: ''}) action: string;
    uploadingFile: boolean = false;
    modalTitle: string = "Subir puntos de interés";
    visible: boolean = true;
    errorMsg: string = '';
    formatSelected: object | null = null;
    formatSelectedRv: object | null = null;
    fileSelected: any = [];
    columnsFormat: string = 'Debe tener las columnas: Nombre, Latitud, Longitud';
    fileContent: any = null;
    fileLoaded: boolean = false;
    formatOptions: Array<object> = [
        {
            id: 0,
            value: "CSV",
            allowedFormat: ".csv"
        },
        {
            id: 1,
            value: "KML",
            allowedFormat: ".kml"
        },
        {
            id: 2,
            value: "Excel",
            allowedFormat: ".xlsx"
        },
        {
            id: 3,
            value: "GeoJson",
            allowedFormat: ".geojson"
        }
    ];
    actionsIds: object = {
        pointsOfInterest: 0,
        geofences: 1
    }

    get canUploadFile() {
        let isUploading = this.uploadingFile;
        let existFile = this.fileSelected.length > 0;
        let formatWasSelected = this.formatSelected !== null;

        if(!formatWasSelected || isUploading || !existFile){
            return false
        }

        return true
    }

    get allowedFormatByFormat() {
        return this.formatSelected
            ? this.formatSelected['allowedFormat']
            : '*';
    }

    updateFormatSelected(value){
        this.clearFile();
        this.formatSelected = value;
    }

    updateFormatSelectedRv(value){
        this.formatSelectedRv = value;
    }


    clearFile() {
        this.fileSelected = [];
        this.fileContent = null;
        this.fileLoaded = false;
    }


   
    

    selectedFile(file) {
        this.fileSelected = file;
    }

    uploadFile() {
        //processing file
        let reader = new FileReader();
        let self = this;
        this.fileContent = null;
        this.fileLoaded = false;
        let file = this.fileSelected[0];
        this.fileContent = file;
        reader.readAsText(file);
        reader.onload = (e: any) => {
            self.fileLoaded = true;
        };

        // //Send file to backend
        let formData = new FormData();
        formData.append('file', this.fileContent);
        formData.append('company_id', this.$_getSelectedCompanyById as string);
        if(this.formatSelected != null){
            formData.append('file_type', this.formatSelected['id']);
        }
        this.submitFile(formData);
    }

    submitFile(formData: FormData) {
        if(this.action == 'pointsOfInterest'){
            this.uploadPointsOfInterest(formData)
        }else{
            //future implementation for geofences
        }
       
    }

    uploadPointsOfInterest(formData: FormData) {
        TrackingService.uploadPointOfInterestFromFile(
            formData
        ).then((res) => {
            let responseHasFailedPoints = res.hasOwnProperty('failed');
            let responseHasSucceedPoints = res.hasOwnProperty('success');
            
            if(responseHasSucceedPoints && res.success.length > 0){
                res.message = `(<b>${res.success.length}</b>) ${res.message}`
            }
            if(responseHasFailedPoints && res.failed.length > 0){
                res.message += `<br><br><b>${res.failed.length} Puntos no se cargaron: </b> ${res.failed.join(', ')}`;
            }
            this.handleSuccessAction(res, 'Puntos de interés cargados correctamente', 15000);
            this.refreshPointsOfInterest();
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'Error al cargar el archivo'
            })
        }).finally(() => {
            this.clearFile();
            this.clearInputModel();
            this.uploadingFile = false;
        })
    }

    clearInputModel(){
        let inputFile: any = this.$refs.inputFileRefer;
        if (inputFile) {
            inputFile.clearModel();
        }
    }


    showUserPreferences(){
        EventBus.$emit(TypeEventBus.SHOW_USER_PREFERENCES);
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }



    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg, timeout){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: timeout
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg, timeout){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg,
            timeout: timeout
        });
    }

    preselectCsv(){
        this.formatSelected = this.formatOptions[0];
    }

   

  

    @Emit()
    closeModal() {}

    @Emit()
    refreshPointsOfInterest() {}


    mounted() {
        this.$nextTick(() => {
            this.preselectCsv();

        });
    }
}
